import { jsx as _jsx } from "preact/jsx-runtime";
import { WebLeadsPanel } from '../WebLeadsPanel';
import { routes } from '@/utils/routes';
// Leads tab now embeds the full WebLeadsPanel. Deep-linking (/leads, /leads/companies) works because
// the panel derives its internal mode from the current URL path.
export function WebLeadsTab({ clientCompanyId, workspaceId, campaignId, web }) {
    const r = routes.scoped(clientCompanyId, workspaceId);
    return (_jsx("div", { className: "rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-6 shadow-sm", children: _jsx(WebLeadsPanel, { clientCompanyId: clientCompanyId, workspaceId: workspaceId, campaignId: campaignId, webId: web.Id, baseWebPath: r.web(campaignId, web.Id), web: { Id: web.Id, Name: web.Name, WebType: web.Type } }) }));
}
